import generateColorModifier from '../generateColorModifier';

export default function getNavigationData(props) {
  const {
    fields: { colorModifiers },
  } = props;

  const data = {};

  data.modifier = colorModifiers?.[0] ? generateColorModifier('Navigation', colorModifiers[0]) : false;

  return Object.keys(data).length ? data : false;
}
